import { useState } from "react";
import { PaziaModal } from "components/molecules";
import { IDropdownOption, PaziaButton, Select } from "components/atoms";
import { ModalHeader } from "../../components/templates/Modals/ModalHeader";
import { ModalPadding } from "../../components/templates/Modals/ModalPadding";
import { coursegroupsApi } from "api";
import { useToaster } from "utils/toaster";

interface BulkAssignCategoryModalProps {
  isOpen: boolean;
  onCloseRequest: () => void;
  selectedCourseGroupIds: number[];
  onSuccess: () => void;
  categoryOptions: IDropdownOption[];
}

export const BulkAssignCategoryModal = ({
  isOpen,
  onCloseRequest,
  selectedCourseGroupIds,
  onSuccess,
  categoryOptions,
}: BulkAssignCategoryModalProps) => {
  const [selectedCategoryId, setSelectedCategoryId] = useState<number | null>(null);
  const [saving, setSaving] = useState(false);
  const { showSuccess, showError } = useToaster();

  const handleSubmit = async () => {
    if (selectedCategoryId == null) return;
    try {
      setSaving(true);
      await coursegroupsApi.bulkAssignCategory({
        courseGroupIds: selectedCourseGroupIds,
        categoryId: selectedCategoryId,
      });
      showSuccess("Przypisano kategorię");
      onSuccess();
      handleClose();
    } catch {
      showError("Nie udało się przypisać kategorii");
    } finally {
      setSaving(false);
    }
  };

  const handleClose = () => {
    setSelectedCategoryId(null);
    onCloseRequest();
  };

  return (
    <PaziaModal id="bulk-assign-category-modal" isOpen={isOpen} onCloseRequest={handleClose} size="full">
      <ModalPadding>
        <ModalHeader>Przypisz kategorię ({selectedCourseGroupIds.length} grup)</ModalHeader>
        <div className="mt-4">
          <Select
            label="Kategoria"
            name="categoryId"
            options={categoryOptions}
            value={selectedCategoryId ?? ""}
            onChange={(opt: IDropdownOption | null) => setSelectedCategoryId(opt ? Number(opt.value) : null)}
            placeholder="Wybierz kategorię..."
          />
        </div>
        <div className="mt-6 flex justify-end gap-3">
          <PaziaButton type="secondary" onClick={handleClose} disabled={saving}>
            Anuluj
          </PaziaButton>
          <PaziaButton
            type="primary"
            onClick={handleSubmit}
            disabled={selectedCategoryId == null || saving}
            processing={saving}
          >
            Przypisz
          </PaziaButton>
        </div>
      </ModalPadding>
    </PaziaModal>
  );
};
